<template>
    <div class="login-form">
        <div class="logoBox">
            <div class="title">
                <img src="../../assets/login/logo.png" alt="">
            </div>
            <p>基于云计算SaaS模式</p>
            <p>收银、营销一体化服务平台</p>
        </div>
        <div class="login">
            <div class="loginType clearfix">
                <div class="loginTypeItem" :class="{active:!isMsg}" style="color:#3068ff" @click="changeLoginType(false)">账号登录</div>
                <!-- <div class="right loginTypeItem" :class="{active:isMsg}" @click="changeLoginType(true)">短信登录</div> -->
            </div>
            <form @submit.prevent="login">
                <div class="inputItem clearfix">
                    <input type="text" style="display: none"> 
                    <input type="tel" ref="fInp" v-model="phone" placeholder="请输入手机号"  id="testInp" autocomplete="off" onfocus="this.type='phone'">
                    <span class="left iconSpan"><i class="iconfont icon-mobile"></i></span>
                    <span class="sendCode" v-if="!isGetCode&&isMsg" @click="getCode">获取验证码</span>
                    <span class="sendCode" v-if="isGetCode&&isMsg">{{time+' s'}}</span>
                </div>
                <div class="inputItem">
                    <input v-if="isMsg" type="tel" v-model="code" placeholder="请输入短信验证码">
                    <input type="text" style="display: none">
                    <input v-if="!isMsg" type="password" v-model="password" placeholder="请输入密码" autocomplete="off" onfocus="this.type='password'">
                    <span class="left iconSpan"><i class="iconfont icon-mima"></i></span>
                </div>
                <div class="forgetPW" style="padding-top:9%;margin-bottom:0;font-size:20px">
                    酒吧/KTV/茶楼等后台登录？<a href="javascript:;" @click.stop="changeUrl">点击切换至旗舰版</a>
                </div>
                <div class="btnGroup clearfix">
                    <button type="submit" class="loginBtn right">登录</button>
                    <button type="button" class="regisBtn left" @click="$router.push({path:'/register'});">注册</button>
                </div>
                <div class="forgetPW">
                    忘记密码？<a href="javascript:;" @click="$router.push({path:'/register/reset'});">重置密码 / 修改密码</a>
                    <a href="/static/火星捕手点单系统安装包_V1.1.3.exe.zip" class="dw" target="_blank" rel="noopener noreferrer">下载收银端</a>
                </div>
            </form>
        </div>
        <div class="com-info">
            <p><a target="_blank" href="http://www.beian.miit.gov.cn">蜀ICP备17028712号-1</a> 火星云网络科技有限公司 huoxingy.co<a target="_blank" style="color:#333" href="/static/bq.zip">m</a></p>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
    	data () {
    		return {
                checked: true,
                isMsg: false, // 是否是短信登录
                isGetCode: false,
                time: 60,
                phone: '', // 手机号
                code: '', // 验证码
                password: '' // 密码
    		}
    	},
        methods: {
            changeUrl(){
                window.location.href = "https://table-admin.huoxingy.com";
            },
            changeLoginType: function ( val ) {
                this.isMsg = val;
            },
            getCode: function () { // 获得验证码事件
                
            },
            login: function () { // 登录事件
                this.phone = this.phone.replace(/\s+/g, "");
                if ( !(/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) ) {
                    this.$message({
                        message:"请输入正确的手机号",
                        customClass: "error"
                    });
                    return;   
                }
                if ( !this.password ) {
                    this.$message({
                        message:"请输入密码",
                        customClass:"error",
                    });
                }
                let data = {
                    "username": this.phone,
                    // "password": hex_md5(this.password),
                    "password": this.password,
                }
                let b = new Base64();
                let authStr = 'Basic '+ b.encode(data.username+':'+data.password);

                
                let loginUrl = 'login';
                if(window.location.href.split('?')[1]){
                    loginUrl = loginUrl+'?openid='+window.location.href.split('?')[1].split('=')[1];
                }
                this.$http.post(loginUrl, {}, {
                    auth: data // 添加登录验证
                }).then((res)=>{
                    localStorage.setItem('token', authStr);
                    localStorage.setItem('username', this.phone);
                    this.$router.push({path:'/store'});
                }).catch((err)=>{
                    if ( err.response ) {
                        if ( err.response.status == 401 ) {
                            this.$message({
                                message: "帐号或者密码有误",
                                customClass: 'error'
                            })
                        } else if ( err.response.status == 403 ) {
                            this.$message({
                                message: "权限不足",
                                customClass: 'error'
                            })
                        } else {
                            this.$message({
                                message: err.response.data,
                                customClass: 'error'
                            })
                        }
                    }
                })
            }
        },
        created: function () {
            // if ( localStorage.getItem('token') && localStorage.getItem('username') ) {
            //     this.$router.push('store');
            // }
            let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            if(width>=450){
                localStorage.removeItem('token');
            }
            if ( localStorage.getItem('token') ) {
                this.$router.push({path:'/store'});
            }
        },
        mounted: function () {
            window.scrollTo(0,0);
            $(document).ready(()=>{
                $('.login-form').height($(window).height());
            });
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../static/css/common.scss';
	@import "login";
</style>



// WEBPACK FOOTER //
// login.vue?633beacf